import employers from '@gov.wa.lni/application.warehouse-retaliation/source/data/employers.json';

export default (context, payload) => {
    const employer = employers.find(x => x.entityName === context.rootState[payload.targetId].value);
    let counties = context.rootState.appState.data.counties;
    let countyCode = counties.find(x => x.text === employer.county);
    if (employer) {
        let updateEmployer = employer;
        updateEmployer.county = countyCode.value;
        context.commit('appState/SET_VALUE', {
            key: 'employer',
            value: updateEmployer,
        }, {
            root: true,
        });

    }
};